// extracted by mini-css-extract-plugin
module.exports =  {"icon":"XDDHWZY","container":"n3o4Co0","content":"FCj0kF8"};